import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

interface IPayment {
  studentName: string;
  studentEmail: string;
  moduleTitle: string;
  moduleWeek: number;
  amount: number;
  paidAt: string;
  stripeSessionId: string;
}

const PaymentDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const token = localStorage.getItem("token");

  const [isLoading, setIsLoading] = useState(true);
  const [payments, setPayments] = useState<IPayment[]>([]);
  const [moduleTitle, setModuleTitle] = useState<string>("");

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/modules/${id}/payments`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setPayments(data);
        if (data.length > 0) {
          setModuleTitle(data[0].moduleTitle); // Primer título disponible
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles de pagos:", error);
        setIsLoading(false);
      });
  }, [id]);

  const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("es-MX", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div className="h-full w-full px-8">
      <div className="flex flex-col items-start gap-4 mt-12">
        <h2 className="font-playfair font-bold text-4xl">
          Todos los pagos del módulo {moduleTitle}
        </h2>
        <div className="w-full flex flex-col">
          {isLoading ? (
            <p>Cargando pagos...</p>
          ) : payments.length > 0 ? (
            payments.map((payment, index) => (
              <div
                key={index}
                className="flex flex-row border-y border-gray-600 py-2 px-12"
              >
                <p className="font-sourceSans">
                  {payment.studentName} pagó el día {formatDate(payment.paidAt)}
                </p>
              </div>
            ))
          ) : (
            <p>No hay pagos disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsPage;
